import { getConterPartyLogo } from '@helpers/constants';
import { getNumberWithTwoDecimal } from '@helpers/miscelleanous';

const transformOpportunityListingData = (opportunities) => {
    return opportunities.map((opportunity) => {
        return {
            id: opportunity?.opportunityId,
            slug: opportunity?.slug,
            title: opportunity?.title,
            logo: opportunity?.logo,
            isin: opportunity?.isin,
            primaryCounterParty: opportunity?.primaryCounterParty,
            displayIRR: getNumberWithTwoDecimal(opportunity?.displayIRR),
            industryType: opportunity?.industryName,
            tenure: opportunity?.tenure,
            paymentSchedule: opportunity?.paymentSchedule,
            minInvestment: opportunity?.minInvestmentAmount,
            opportunityRiskRatings: opportunity?.opportunityRiskRatings,
            accessCode: opportunity?.accessCode,
            bondType: opportunity?.bondType,
            borrower: opportunity?.borrower,
            displayAssetClass: opportunity?.displayAssetClass,
            instrument: opportunity?.instrument,
            state: opportunity?.state,
            type: opportunity?.type,
            tagType: opportunity?.tag?.name,
            tagLabel: opportunity?.tag?.displayName,
            displayRating: opportunity?.displayRating,
            interestPayoutFrequency: opportunity?.interestPayoutFrequency
        };
    });
};

const transformOpportunityListingDataLoggedInView = (opportunities) => {
    return opportunities.map((opportunity) => {
        return {
            id: opportunity?.id,
            slug: opportunity?.slug,
            title: opportunity?.title,
            isin: opportunity?.isin,
            logo: getConterPartyLogo(opportunity),
            primaryCounterParty: opportunity?.primaryCounterParty,
            displayIRR: getNumberWithTwoDecimal(opportunity?.displayIRR),
            industryType: opportunity?.industryType?.name,
            tenure: opportunity?.tenure,
            paymentSchedule: opportunity?.paymentSchedule,
            minInvestment: opportunity?.minInvestmentAmount,
            opportunityRiskRatings: opportunity?.opportunityRiskRatings,
            accessCode: opportunity?.accessCode,
            bondType: opportunity?.bondType,
            borrower: opportunity?.borrower,
            displayAssetClass: opportunity?.displayAssetClass,
            instrument: opportunity?.instrument,
            state: opportunity?.state,
            type: opportunity?.type,
            tagType: opportunity?.tag?.name,
            tagLabel: opportunity?.tag?.displayName,
            displayRating: opportunity?.opportunityRiskRatings
                ? getRiskRatingName(opportunity.opportunityRiskRatings?.[0])
                : '-',
            opportunityPreFestiveOfferIRR: opportunity?.opportunityPreFestiveOffer ? getNumberWithTwoDecimal( opportunity.opportunityPreFestiveOffer?.preOfferIRR) : null,
            interestPayoutFrequency: opportunity?.interestPayoutFrequency
        };
    });
};

const getRiskRatingName = (opportunityRiskRatings) => {
    const opportunityRating = opportunityRiskRatings.riskRating;
    const rating = opportunityRating?.riskRating ? opportunityRating?.riskRating : '';
    return opportunityRiskRatings?.counterParty.name + " " + rating;
}

export { transformOpportunityListingData, transformOpportunityListingDataLoggedInView };
